export const EXECUTIVE_COMMITTEE = 'executive';
export const MANAGEMENT_COMMITTEE = 'management';
export const MANAGEMENT_TARGET_COUNT = 6;

export const EXECUTIVE_ROLES = [
  { key: 'president', label: 'President', order: 1 },
  { key: 'president_elect', label: 'President Elect', order: 2 },
  { key: 'immediate_past_president', label: 'Immediate Past President', order: 3 },
  { key: 'honorable_secretary', label: 'Honorable Secretary', order: 4 },
  { key: 'assistant_secretary', label: 'Assistant Secretary', order: 5 },
  { key: 'treasurer', label: 'Treasurer', order: 6 },
];

const roleByKey = Object.fromEntries(EXECUTIVE_ROLES.map((r) => [r.key, r]));

export const getExecutiveRoleLabel = (key) => roleByKey[key]?.label || key || '';

export const getExecutiveRoleOrder = (key) => roleByKey[key]?.order ?? 99;

export const sortExecutiveMembers = (members) =>
  [...members].sort((a, b) => getExecutiveRoleOrder(a.role) - getExecutiveRoleOrder(b.role));

export const buildExecutiveSlots = (members) => {
  const byRole = Object.fromEntries(
    members.filter((m) => m.committee === EXECUTIVE_COMMITTEE).map((m) => [m.role, m])
  );
  return EXECUTIVE_ROLES.map((role) => ({
    ...role,
    member: byRole[role.key] || null,
  }));
};

export const sortManagementMembers = (members) =>
  [...members].sort((a, b) => {
    const orderDiff = (a.display_order ?? 0) - (b.display_order ?? 0);
    if (orderDiff !== 0) return orderDiff;
    return (a.name || '').localeCompare(b.name || '');
  });

export const getManagementRoleLabel = (role) => (role?.trim() ? role.trim() : 'Member');

/** Invitation letter page-2 footer: Executive column, then Management split across two columns. */
export const buildLeadershipFooterFromMembers = (members = []) => {
  const executiveColumn = buildExecutiveSlots(members)
    .filter((slot) => slot.member?.name?.trim())
    .map((slot) => ({
      role: slot.label,
      name: slot.member.name.trim(),
    }));

  const managementEntries = sortManagementMembers(
    members.filter((m) => m.committee === MANAGEMENT_COMMITTEE && m.name?.trim())
  ).map((m) => ({
    role: getManagementRoleLabel(m.role),
    name: m.name.trim(),
  }));

  const mid = Math.ceil(managementEntries.length / 2);
  const columns = [
    executiveColumn,
    managementEntries.slice(0, mid),
    managementEntries.slice(mid),
  ].filter((col) => col.length > 0);

  return { columns };
};

export const getHomepageLeaders = (allMembers) => {
  const featured = allMembers.filter((m) => m.featured);
  if (featured.length > 0) {
    const executive = sortExecutiveMembers(
      featured.filter((m) => m.committee === EXECUTIVE_COMMITTEE)
    );
    const management = sortManagementMembers(
      featured.filter((m) => m.committee === MANAGEMENT_COMMITTEE)
    );
    return [...executive, ...management].slice(0, 4);
  }

  const president = allMembers.find(
    (m) => m.committee === EXECUTIVE_COMMITTEE && m.role === 'president' && m.name
  );
  return president ? [president] : [];
};
